// Vendors
import React, { createContext, PropsWithChildren, useContext, useState } from 'react';
// Enumerations
import { ContractStatesEnumeration } from 'containers/contract/enumerations/contract-states.enumeration';
// Hooks
import { useAppContextConsumerHook } from 'contexts/app.context';
// Types
import { ContractContextType } from './types/contract.contexts.type';
import { IbanListType } from '../components/iban-selector/types/iban-list.type';
// Utils
import { getContractStateFromCurrentState } from './utils/contract.context.utils';

const ContractContext = createContext<ContractContextType>({} as ContractContextType);

const ContractContextProvider = ({ children }: PropsWithChildren): React.ReactElement => {
  const { currentState } = useAppContextConsumerHook();

  const [contractState, setContractState] = useState<ContractStatesEnumeration>(
    getContractStateFromCurrentState(currentState)
  );
  const [otpId, setOtpId] = useState<string>('');
  const [ibanList, setIbanList] = useState<IbanListType>([]);
  const [selectedIban, setSelectedIban] = useState<string>('');
  const [fetchingSave, setFetchingSave] = useState(false);

  return (
    <ContractContext.Provider
      value={{
        contractState,
        fetchingSave,
        ibanList,
        otpId,
        selectedIban,
        setContractState,
        setFetchingSave,
        setIbanList,
        setOtpId,
        setSelectedIban,
      }}
    >
      {children}
    </ContractContext.Provider>
  );
};

const useContractContextConsumerHook = (): ContractContextType => useContext(ContractContext);

/* eslint-disable */
const ContractContextConsumerHOC =
  (Component: React.FunctionComponent<any>): React.FunctionComponent<any> =>
  (props: any): React.ReactElement<React.Provider<any>> =>
    (
      <ContractContextProvider>
        <Component {...props} />
      </ContractContextProvider>
    );

export { ContractContextConsumerHOC, useContractContextConsumerHook, ContractContextProvider };
